import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Générer ou récupérer un ID de session unique
    let sessionId = sessionStorage.getItem('visitor_session_id');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('visitor_session_id', sessionId);
    }

    // Enregistrer la visite
    const trackPageVisit = async () => {
      try {
        const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
        
        const visitData = {
          page_path: location.pathname,
          referrer: document.referrer || null,
          session_id: sessionId
        };

        await fetch(`${backendUrl}/api/stats/visit`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(visitData),
        });

        // Ne pas afficher d'erreur si le tracking échoue (silent fail)
      } catch (error) {
        // Silent fail - ne pas perturber l'expérience utilisateur
        console.debug('Page tracking error:', error);
      }
    };

    trackPageVisit();
  }, [location]);
};

export default usePageTracking;
